import React from 'react'
import PropTypes from 'prop-types'
import PerformanceRatingAndCompaRatioDetailReport from './PerformanceRatingAndCompaRatioDetailReport'
import { range, find, get, forEach as objectEach } from 'lodash'
import { round } from '../../../../../helpers'
import DataFilters from '../../DataFilters'

export default function PerformanceRatingAndCompaRatioDetail(props) {

	const groups = ['E', 'M', 'P', 'S']

	const groupsNames = {
		'E': 'Executive (E)',
		'M': 'People Mgmt (M)',
		'P': 'Professional IC (P)',
		'S': 'Support (S)',
	}

	const onApply = (filters) => {
		props.onApply(filters, 'PerformanceRatingAndCompaRatioDetail')
	}

	const levelsData = []
	const groupSummary = {}
	let currentTotalN = 0

	const columnsForThisReport = [ 'comp_salary_p50', 'comp_salary_p75', 'comp_ttc_p50', 'comp_ttc_p75']

	let numberOfDynamicColumns = 0

	groups.forEach(g => {
		groupSummary[g] = {
			current: { total_average_rating_row:0, total_salary_p50_row:0, total_salary_p75_row: 0, total_comp_ttc_p50_row: 0, total_comp_ttc_p75_row: 0,
				totalN: 0, total_average_rating: 0, total_salary_p50: 0, total_salary_p75: 0,  total_comp_ttc_p50: 0,  total_comp_ttc_p75: 0
			}
		}
	})

	range(14).forEach(level => {
		const levelData = props.masterData.jobGrades.filter(hd => hd.hierarchy === level)
		const groupData = {}
		groups.forEach(g => {
			groupData[g] = {
				level: '',
				title: '',
				current: { n: '', salary_p50: '', salary_p75: '', comp_ttc_p50: '', comp_ttc_p75: '' },
			}
		})

		levelData.forEach(ld => {
			const groupKey = ld.job_grade.slice(0, 1)
			const dataInReport = find(props.reportData, { 'compkit_job_grade': ld.job_grade })

			groupData[groupKey].level = ld.job_grade
			groupData[groupKey].title = ld.job_title

			if (dataInReport) {
				groupData[groupKey].current.n = get(dataInReport, 'total', 0)
				groupData[groupKey].current.averageRating = round(get(dataInReport, 'avg_performance_rating', 0))
				groupData[groupKey].current.salary_p50 = round(get(dataInReport, 'avg_comp_salary_p50', 0))
				groupData[groupKey].current.salary_p75 = round(get(dataInReport, 'avg_comp_salary_p75', 0))
				groupData[groupKey].current.comp_ttc_p50 = round(get(dataInReport, 'avg_comp_ttc_p50', 0))
				groupData[groupKey].current.comp_ttc_p75 = round(get(dataInReport, 'avg_comp_ttc_p75', 0))

				groupSummary[groupKey].current.totalN += groupData[groupKey].current.n
				groupSummary[groupKey].current.total_average_rating += groupData[groupKey].current.averageRating
				if(groupData[groupKey].current.averageRating) {
					groupSummary[groupKey].current.total_average_rating_row += 1
				}
				if(groupData[groupKey].current.salary_p50) {
					groupSummary[groupKey].current.total_salary_p50_row += 1
				}
				if(groupData[groupKey].current.salary_p75) {
					groupSummary[groupKey].current.total_salary_p75_row += 1
				}
				if(groupData[groupKey].current.comp_ttc_p50) {
					groupSummary[groupKey].current.total_comp_ttc_p50_row += 1
				}
				if(groupData[groupKey].current.comp_ttc_p75) {
					groupSummary[groupKey].current.total_comp_ttc_p75_row += 1
				}
				groupSummary[groupKey].current.total_salary_p50 = round(groupSummary[groupKey].current.total_salary_p50 + groupData[groupKey].current.salary_p50)
				groupSummary[groupKey].current.total_salary_p75 = round(groupSummary[groupKey].current.total_salary_p75 + groupData[groupKey].current.salary_p75)
				groupSummary[groupKey].current.total_comp_ttc_p50 = round(groupSummary[groupKey].current.total_comp_ttc_p50 + groupData[groupKey].current.comp_ttc_p50)
				groupSummary[groupKey].current.total_comp_ttc_p75 = round(groupSummary[groupKey].current.total_comp_ttc_p75 + groupData[groupKey].current.comp_ttc_p75)

				/**
				 * Below is the Display Logic
				 * For Each Row
				 */
				groupData[groupKey].current.averageRating = groupData[groupKey].current.averageRating.toFixed(1)
				groupData[groupKey].current.salary_p50 = groupData[groupKey].current.salary_p50.toFixed(1)
				groupData[groupKey].current.salary_p75 = groupData[groupKey].current.salary_p75.toFixed(1)
				groupData[groupKey].current.comp_ttc_p50 = groupData[groupKey].current.comp_ttc_p50.toFixed(1)
				groupData[groupKey].current.comp_ttc_p75 = groupData[groupKey].current.comp_ttc_p75.toFixed(1)

			}
		})
		levelsData.push(groupData)
	})

	Object.keys(groupSummary).forEach(key => {
		currentTotalN = round(currentTotalN + groupSummary[key].current.totalN)
		groupSummary[key].current.total_average_rating = round(groupSummary[key].current.total_average_rating / groupSummary[key].current.total_average_rating_row).toFixed(1)
		groupSummary[key].current.total_salary_p50 = round(groupSummary[key].current.total_salary_p50 / groupSummary[key].current.total_salary_p50_row).toFixed(1)
		groupSummary[key].current.total_salary_p75 = round(groupSummary[key].current.total_salary_p75 / groupSummary[key].current.total_salary_p75_row).toFixed(1)
		groupSummary[key].current.total_comp_ttc_p50 = round(groupSummary[key].current.total_comp_ttc_p50 / groupSummary[key].current.total_comp_ttc_p50_row).toFixed(1)
		groupSummary[key].current.total_comp_ttc_p75 = round(groupSummary[key].current.total_comp_ttc_p75 / groupSummary[key].current.total_comp_ttc_p75_row).toFixed(1)
	})


	objectEach((props.availableColumns), function (value, key) {
		if(columnsForThisReport.indexOf(key) !== -1) {
			if(value) {
				numberOfDynamicColumns += 1
			}
		}
	})

	return (
		<React.Fragment>
			<DataFilters
				fetchedFilterData={props.fetchedFilterData}
				filtersData={props.filtersData}
				onDataFilterSelect={props.onDataFilterSelect}
				componentName={'PerformanceRatingAndCompaRatioDetail'}
				reportFilters={props.reportFilters}
				onApply={onApply}
				resetFilter={props.resetFilter}
				reportFiltersType={props.reportFiltersType}
				reportDataChanged={props.reportDataChanged}
			/>
			<PerformanceRatingAndCompaRatioDetailReport numberOfDynamicColumns={numberOfDynamicColumns} availableColumns={props.availableColumns} currentTotalN={currentTotalN} groupSummary={groupSummary} groups={groups} groupsNames={groupsNames} levelsData={levelsData}></PerformanceRatingAndCompaRatioDetailReport>
        </React.Fragment>
    )
}

PerformanceRatingAndCompaRatioDetail.propTypes = {
	masterData: PropTypes.object.isRequired,
	onDataFilterSelect: PropTypes.func.isRequired,
	reportFilters: PropTypes.object.isRequired,
	reportData: PropTypes.array.isRequired,
	onApply: PropTypes.func.isRequired,
}
